module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "OldFlames_epub-5.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "CT-new-page"
  }, [_c('span', {
    staticClass: "Section-Symbol char-style-override-14"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("cknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-10"
  }, [_vm._v("To "), _c('span', {
    staticClass: "char-style-override-15"
  }, [_vm._v("Daniel Edelman")]), _vm._v(" of Ridgefield, Connecticut, who put a roof over my head while I wrote chunks of this.")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-10"
  }, [_vm._v("To "), _c('span', {
    staticClass: "char-style-override-15"
  }, [_vm._v("Arthur Cantor")]), _vm._v(", who did the same in Manhattan.")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-10"
  }, [_vm._v("To "), _c('span', {
    staticClass: "char-style-override-15"
  }, [_vm._v("Sarah Teale")]), _vm._v(", who got between me and the phone and the fax for the best part of four months.")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-10"
  }, [_vm._v("To "), _c('span', {
    staticClass: "char-style-override-15"
  }, [_vm._v("Art Tatum")]), _vm._v(", who in 1956, the last year of his life, recorded session after session of his finest work, and kept me intrigued and listening forty years on.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1bccfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OldFlames_epub5.vue
// module id = 75
// module chunks = 0